import '../assets/NcActionRouter-B0l-dISs.css';
import { A as ActionTextMixin } from "./actionText-aI0owku1.mjs";
import { resolveComponent, openBlock, createElementBlock, createVNode, withCtx, renderSlot, createElementVNode, normalizeClass, normalizeStyle, toDisplayString, createCommentVNode, pushScopeId, popScopeId } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcActionRouter",
  mixins: [ActionTextMixin],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: false
    }
  },
  props: {
    /**
     * router-link to prop [https://router.vuejs.org/api/#to](https://router.vuejs.org/api/#to)
     */
    to: {
      type: [String, Object],
      default: "",
      required: true
    }
  }
};
const _withScopeId = (n) => (pushScopeId("data-v-4d03878a"), n = n(), popScopeId(), n);
const _hoisted_1 = ["role"];
const _hoisted_2 = {
  key: 0,
  class: "action-router__longtext-wrapper"
};
const _hoisted_3 = { class: "action-router__name" };
const _hoisted_4 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("br", null, null, -1));
const _hoisted_5 = ["textContent"];
const _hoisted_6 = ["textContent"];
const _hoisted_7 = {
  key: 2,
  class: "action-router__text"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = resolveComponent("RouterLink");
  return openBlock(), createElementBlock("li", {
    class: "action",
    role: $options.isInSemanticMenu && "presentation"
  }, [
    createVNode(_component_RouterLink, {
      to: $props.to,
      "aria-label": _ctx.ariaLabel,
      title: _ctx.title,
      class: "action-router focusable",
      rel: "nofollow noreferrer noopener",
      role: $options.isInSemanticMenu && "menuitem",
      onClick: _ctx.onClick
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "icon", {}, () => [
          createElementVNode("span", {
            class: normalizeClass([[_ctx.isIconUrl ? "action-router__icon--url" : _ctx.icon], "action-router__icon"]),
            style: normalizeStyle({ backgroundImage: _ctx.isIconUrl ? `url(${_ctx.icon})` : null }),
            "aria-hidden": "true"
          }, null, 6)
        ], true),
        _ctx.name ? (openBlock(), createElementBlock("span", _hoisted_2, [
          createElementVNode("strong", _hoisted_3, toDisplayString(_ctx.name), 1),
          _hoisted_4,
          createElementVNode("span", {
            class: "action-router__longtext",
            textContent: toDisplayString(_ctx.text)
          }, null, 8, _hoisted_5)
        ])) : _ctx.isLongText ? (openBlock(), createElementBlock("span", {
          key: 1,
          class: "action-router__longtext",
          textContent: toDisplayString(_ctx.text)
        }, null, 8, _hoisted_6)) : (openBlock(), createElementBlock("span", _hoisted_7, toDisplayString(_ctx.text), 1)),
        createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["to", "aria-label", "title", "role", "onClick"])
  ], 8, _hoisted_1);
}
const NcActionRouter = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-4d03878a"]]);
export {
  NcActionRouter as N
};
